"use strict";

exports.__esModule = true;
exports.DeviceTypeFilter = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DropdownCheckboxList = require("../../Core/DropdownCheckboxList");
var _DeviceTypeListContext = require("../../Device/DeviceTypeListContext");
var _URLFilter = require("../../Core/URLFilter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DeviceTypeFilter = exports.DeviceTypeFilter = function DeviceTypeFilter() {
  var deviceTypes = _react["default"].useContext(_DeviceTypeListContext.DeviceTypeListContext);
  var _React$useContext = _react["default"].useContext(_URLFilter.URLFilterContext),
    filters = _React$useContext.filters,
    setFilter = _React$useContext.setFilter;
  return /*#__PURE__*/_react["default"].createElement(_DropdownCheckboxList.DropdownCheckboxList, {
    minimal: true,
    style: {
      maxWidth: 250,
      marginRight: "1rem"
    },
    items: [].concat(deviceTypes, ["MTConnectDevice"]).sort(),
    selected: filters.deviceTypes,
    multiple: true,
    toggle: true,
    onSelect: function onSelect(deviceTypes) {
      return setFilter("deviceTypes", deviceTypes);
    },
    itemPredicate: function itemPredicate(query, item) {
      return item.toLowerCase().includes(query.toLowerCase());
    },
    renderItemText: function renderItemText(item) {
      return item;
    },
    getKey: function getKey(item) {
      return item;
    },
    placeholder: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "DashboardToolbar.deviceTypeList.placeholder",
      defaultMessage: "Types"
    }),
    dataTestId: "DeviceTypeSelector"
  });
};